import React from 'react';
import styled from 'styled-components';

const ContactSection = styled.section`
  padding: 80px 0;
  background-color: #f0f9ff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div``;

const ContactForm = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
`;

const FormTitle = styled.h3`
  color: #6a1b9a;
  font-size: 24px;
  margin-bottom: 20px;
`;

const Form = styled.form``;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  color: #555;
  font-size: 14px;
  margin-bottom: 8px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #00b8d4;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  min-height: 150px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #00b8d4;
  }
`;

const SubmitButton = styled.button`
  background-color: #ff6f00;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 30px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #ff9100;
  }
`;

const InfoBox = styled.div`
  margin-bottom: 30px;
`;

const InfoTitle = styled.h3`
  color: #6a1b9a;
  font-size: 24px;
  margin-bottom: 20px;
`;

const InfoText = styled.p`
  color: #555;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const InfoIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e1bee7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #6a1b9a;
  font-size: 18px;
`;

const MapContainer = styled.div`
  height: 300px;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contato">
      <SectionTitle>Contato</SectionTitle>
      <SectionSubtitle>
        Sorrisos Saudáveis Começam Aqui! Agende Uma Consulta Agora Mesmo!
      </SectionSubtitle>
      <Divider />
      
      <ContactContainer>
        <ContactInfo>
          <InfoBox>
            <InfoTitle>Informações de Contato</InfoTitle>
            <InfoText>
              Entre em contato conosco para agendar uma consulta ou esclarecer dúvidas sobre nossos serviços.
            </InfoText>
            
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-map-marker-alt"></i>
              </InfoIcon>
              <div>
                <strong>Endereço:</strong><br />
                R. Exemplo, 123 - Bairro, Cidade - Estado
              </div>
            </InfoItem>
            
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-phone"></i>
              </InfoIcon>
              <div>
                <strong>Telefone:</strong><br />
                (00) 00000-0000
              </div>
            </InfoItem>
            
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-clock"></i>
              </InfoIcon>
              <div>
                <strong>Horário de Atendimento:</strong><br />
                Segunda a Sexta: 8h às 17h
              </div>
            </InfoItem>
            
            <InfoItem>
              <InfoIcon>
                <i className="fas fa-envelope"></i>
              </InfoIcon>
              <div>
                <strong>E-mail:</strong><br />
                contato@dentinhosdeleite.com.br
              </div>
            </InfoItem>
          </InfoBox>
          
          <MapContainer>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.3570607892396!2d-43.133508384416566!3d-22.906453143591854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDA1JzIzLjIiUyA0M8KwMDcnNTUuOSJX!5e0!3m2!1spt-BR!2sbr!4v1621436761619!5m2!1spt-BR!2sbr" 
              title="Localização do Ateliê Dentinhos de Leite"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </MapContainer>
        </ContactInfo>
        
        <ContactForm>
          <FormTitle>Agende sua Consulta</FormTitle>
          <Form>
            <FormGroup>
              <Label htmlFor="name">Nome Completo</Label>
              <Input type="text" id="name" placeholder="Digite seu nome" />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="email">E-mail</Label>
              <Input type="email" id="email" placeholder="Digite seu e-mail" />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="phone">Telefone</Label>
              <Input type="tel" id="phone" placeholder="Digite seu telefone" />
            </FormGroup>
            
            <FormGroup>
              <Label htmlFor="message">Mensagem</Label>
              <TextArea id="message" placeholder="Como podemos ajudar?"></TextArea>
            </FormGroup>
            
            <SubmitButton type="submit">Enviar Mensagem</SubmitButton>
          </Form>
        </ContactForm>
      </ContactContainer>
    </ContactSection>
  );
};

export default Contact;
